import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    productByIdType,
    productByNameType,
} from "./__graphql-types__/index.ts";

// Query to get product by id
export const PRODUCT_BY_ID_QUERY: GqlOperation<
    productByIdType["response"],
    productByIdType["variables"]
> = gqlOp(gql`
    query productById($id: ID) {
        product(id: $id) {
            id
            name
            isActive
            description
            extProductID
            validationBillingCountries
            prices {
                currency
                extProductID
                id
                recurringInterval
                recurringIntervalCount
                type
                unitAmount
            }
        }
    }
`);

// Query to get product by name
export const PRODUCT_BY_NAME_QUERY: GqlOperation<
    productByNameType["response"],
    productByNameType["variables"]
> = gqlOp(gql`
    query productByName($name: String!) {
        productByName(name: $name) {
            id
            name
            isActive
            description
            extProductID
            validationBillingCountries
            prices {
                currency
                extProductID
                id
                recurringInterval
                recurringIntervalCount
                type
                unitAmount
            }
        }
    }
`);
